module.exports = __webpack_public_path__ + "static/media/other-img-4.05124834.png";